"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var ksys_app_template_1 = require("@kurtosys/ksys-app-template");

var mobx_react_1 = require("mobx-react");

var mobx_1 = require("mobx");

var shared_1 = require("../../../shared");

var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));

var MorningStarIcon_1 = __importDefault(require("./styledComponents/MorningStarIcon"));

var MorningStarIconWrapper_1 = __importDefault(require("./styledComponents/MorningStarIconWrapper"));

var MorningStar_meta_1 = require("./MorningStar.meta");

var Translate_1 = __importDefault(require("../Translate"));

var MorningStar =
/** @class */
function (_super) {
  __extends(MorningStar, _super);

  function MorningStar(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = MorningStar_meta_1.MORNING_STAR_CATEGORY_KEY;
    _this.componentKey = MorningStar_meta_1.MORNING_STAR_COMPONENT_KEY;
    return _this;
  }

  Object.defineProperty(MorningStar.prototype, "morningStars", {
    get: function get() {
      var morningStarRating = this.props.morningStarRating;

      if (morningStarRating && !ksys_app_template_1.utils.typeChecks.isNumber(morningStarRating)) {
        morningStarRating = parseInt(morningStarRating, 10);

        if (Number.isNaN(morningStarRating)) {
          morningStarRating = 0;
        }
      }

      var noRatingPlaceholderText = this.props.noRatingPlaceholderText;

      if (!morningStarRating) {
        if (noRatingPlaceholderText) {
          return react_1.default.createElement(Translate_1.default, null, noRatingPlaceholderText);
        }

        return null;
      }

      var maxStarRating = 5;

      if (morningStarRating > maxStarRating) {
        morningStarRating = maxStarRating;
      }

      var stars = [];

      for (var i = 0; i < morningStarRating; i++) {
        stars.push(react_1.default.createElement(MorningStarIconWrapper_1.default, {
          key: "star_" + i,
          "aria-hidden": true
        }, react_1.default.createElement(MorningStarIcon_1.default, null)));
      }

      return stars;
    },
    enumerable: true,
    configurable: true
  });

  MorningStar.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        morningStarRating = _a.morningStarRating;
    return react_1.default.createElement(Wrapper_1.default, {
      className: className,
      role: "text",
      "aria-label": "" + morningStarRating
    }, this.morningStars);
  };

  __decorate([mobx_1.computed], MorningStar.prototype, "morningStars", null);

  MorningStar = __decorate([mobx_react_1.observer], MorningStar);
  return MorningStar;
}(shared_1.ComponentBase);

exports.MorningStar = MorningStar;
exports.default = shared_1.InjectedStyledComponent(MorningStar, MorningStar_meta_1.MORNING_STAR_CATEGORY_KEY, MorningStar_meta_1.MORNING_STAR_COMPONENT_KEY);